/**
 * Reset Button Component
 *
 * A universal reset button that can be used by any control group.
 * Simple, reusable, and follows DRY principle.
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import './style.scss';

import { Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { rotateLeft } from '@wordpress/icons';
import React from 'react';

import type { ResetButtonProps } from './types';

/**
 * Universal Reset Button Component
 *
 * Can be used by any control group (background, spacing, typography, etc.)
 */
export const ResetButton: React.FC< ResetButtonProps > = ( {
	onReset,
	show = true,
	label = __( 'Reset', 'redfox-thank-you' ),
	className = '',
	variant = 'secondary',
	size = 'small',
	showIcon = true,
	disabled = false,
	showLabel = false,
} ) => {
	if ( ! show ) {
		return null;
	}

	const buttonClasses = `redfox-thank-you-reset-button ${ className }`.trim();

	return (
		<Button
			variant={ variant }
			size={ size }
			icon={ showIcon ? rotateLeft : undefined }
			iconSize={ 20 }
			onClick={ onReset }
			className={ buttonClasses }
			disabled={ disabled }
			title={ label }
		>
			{ showLabel && label }
			{ ! showLabel && (
				<span className="screen-reader-text">{ label }</span>
			) }
		</Button>
	);
};
